class SampleStepper extends HTMLElement {
    helpers = {
        isValid: "is-valid",
        visibile: 'visible',
        opacity: 1,
        unset: ''
    }

    constructor() {
        super()

        this.stepperWrapper = this.querySelector(".stepper-progress-wrapper")
        this.stepperHeader = this.querySelector(".stepper-header")
        this.stepperContent = this.querySelector(".stepper-content")
        this.formSuccessContainer = this.querySelector(".stepper-form-success")

        this.progressBar = this.querySelector(".stepper-progress")
        this.progresSteps = this.querySelectorAll(".step")
        this.stepperFieldSet = this.querySelectorAll("fieldset")

        this.progresSteps.forEach((step) => {
            step.addEventListener("click", this.handleStepClick.bind(this))
        })
        this.stepperFieldSet.forEach((stepperFieldset) => {
            stepperFieldset.querySelector("form").addEventListener("submit", this.handleFormSubmit.bind(this))
        })
        this.fieldFields = this.querySelectorAll("input[type='file']")
        this.fieldFields.forEach((fieldField) => {
            fieldField.addEventListener("change", this.handleFileUpload.bind(this))
        })
        this.goToStep(0)
    }

    handleStepClick(event) {
        const clickedElement = event.currentTarget
        if (clickedElement.classList.contains("completed")) {
            return this.goToStep(parseInt(clickedElement.getAttribute("data-step")))
        }
    }

    goToStep(stepIndex) {
        if (stepIndex < 0 || stepIndex >= this.stepperFieldSet.length) {
            return
        }

        this.currentStep = stepIndex

        this.stepperFieldSet.forEach((stepperFieldset, index) => {
            if (stepIndex == index) {
                stepperFieldset.classList.add(this.helpers.visibile)
            } else {
                stepperFieldset.classList.remove(this.helpers.visibile)
            }
        })

        this.progresSteps.forEach((progressStep, index) => {
            if (stepIndex >= index) {
                progressStep.classList.add(this.helpers.isValid)
            } else {
                progressStep.classList.remove(this.helpers.isValid)
            }
        })
        this.stepperWrapper.dataset.currentStep = stepIndex
    }

    handleFileUpload(e) {
        e.currentTarget.labels.forEach((label, index) => {
            label.style.display = index == 0 ? 'none' : ''
        })
    }

    handleFormSubmit(e) {
        e.preventDefault()
        const form = e.currentTarget
        const formStepIndex = parseInt(form.parentElement.getAttribute("data-step-index"))
        const isLastStep = formStepIndex >= this.stepperFieldSet.length - 1

        if (isLastStep) {
            return this.submitRequest(e)
        }
        this.progresSteps[formStepIndex].classList.add("completed")
        return this.goToStep(formStepIndex + 1)
    }

    submitRequest(event) {
        const formData = new FormData()
        this.querySelectorAll("form").forEach((form) => {
            let formInfo = new FormData(form)
            for (var pair of formInfo.entries()) {
                formData.append(pair[0], pair[1]);
            }
        })

        const submitterBtn = event.submitter
        submitterBtn.classList.add("loading")
        submitterBtn.setAttribute("disabled", true)
        const loadingSpinner = submitterBtn.querySelector(".loading-overlay__spinner")
        loadingSpinner.classList.remove("hidden")

        fetch("https://formspree.io/f/mrgvybeq", {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
        })
        .then(this.handleSuccess.bind(this))
        .catch(this.handleFailure.bind(this))
    }

    handleSuccess(response) {
        this.querySelectorAll("form").forEach((form) => form.reset())
        this.formSuccessContainer.classList.add("show")
        this.stepperHeader.classList.add("hide")
        this.stepperContent.classList.add("hide")
    }

    handleFailure(response) {
    }
}

customElements.define('sample-stepper', SampleStepper);
